export default function useAvailability() {
    const getDateTimeRestrictions = (forms, selectedWorkerId = null) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/v1/availability/date-time-restrictions/${forms.slug}` + (selectedWorkerId ? `/${selectedWorkerId}` : ''), {})
                .then((response) => {
                    resolve(formatDateTimeRestrictions(response.data));
                }).catch((error) => {
                    reject(error);
            })
        })
    }

    const getTimeslots = (forms, selectedDay, selectedWorkerId = null, selectedServiceId = null) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/v1/availability/time-slots/${forms.slug}/${selectedDay}` + (selectedServiceId ? `/${selectedServiceId}` : '') + (selectedWorkerId ? `/${selectedWorkerId}` : ''), {})
                .then((response) => {
                    if (response.data.status === 'error') {
                        window.location.href = '/temporary-outage';
                    }
                    resolve(response.data);
                }).catch((error) => {
                reject(error);
            })
        })
    }

    const getCalendarDates = (forms, selectedWorkerId = null, selectedServiceId = null, refresh = false) => {
        return new Promise((resolve, reject) => {
            const params = refresh ? '?refresh=true' : ''
            axios.get(`/api/v1/availability/dates/${forms.slug}` + (selectedServiceId ? `/${selectedServiceId}` : '') + (selectedWorkerId ? `/${selectedWorkerId}` : '') + params, {})
                .then((response) => {
                    resolve(response.data);
                }).catch((error) => {
                reject(error);
            })
        })
    }

    const formatDateTimeRestrictions = (raw) => {
        return {
            min: new Date(raw.min),
            max: new Date(raw.max),
            disabled: raw.disabled.map(slot => ({
                start: new Date(slot.start),
                repeat: {
                    weekdays: slot.repeat.weekdays,
                    until: new Date(slot.repeat.until)
                }
            }))
        };
    };

    return {
        getDateTimeRestrictions,
        formatDateTimeRestrictions,
        getTimeslots,
        getCalendarDates,
    }
}
